import { observer } from 'mobx-react-lite'
import { Typography } from 'shared/ui'
import { AssignNumberCommon } from 'entities/Phone'
import { useTextEnableLandlineStepsContext } from 'pages/settings/pages/numbers/pages/TextEnableLandline/context/useTextEnableLandlineStepsContext'
import styles from './styles.module.scss'

export const AssignNumber = observer(() => {
  const { assignNumberStore } = useTextEnableLandlineStepsContext()
  const { assignNumberCommonStore } = assignNumberStore

  return (
    <div className={styles.wrap}>
      <Typography
        tag={'div'}
        color='tertiary'
        variant='body-md-regular'
        ariaLabel='EnterNumberDescription'
        marginTop='16px'
      >
        To call and send messages from your number, assign it to an inbox
      </Typography>

      <div className={styles.content}>
        <AssignNumberCommon store={assignNumberCommonStore} />
      </div>
    </div>
  )
})
